import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ButtonModel, ModalContext } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import {
  getProductView_productDetailByMasterId,
  getProductView_productDetailByMasterId_variants,
} from '../../../queries/__generated__/getProductView';
import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { trackModalClose, trackModalOpen } from './gtm/tracking';
import { messages } from './messages';
import { ClickAndCollectModal } from './Modal';
import { messages as modalMessages } from './Modal/messages';
import { PickUpButton, PickUpButtonWrapper } from './styled';

type IClickAndCollectProps = {
  selectedVariant: getProductView_productDetailByMasterId_variants;
  product: getProductView_productDetailByMasterId;
  onModalClosing: () => void;
  disabled?: boolean;
};

export const ClickAndCollect: React.FC<IClickAndCollectProps> = ({
  selectedVariant,
  product,
  onModalClosing,
  disabled = false,
}) => {
  const newDesign = useNewPdDesignEnabled();
  const { formatMessage } = useIntl();
  const { getTimeFromInit } = useTrackingContext();
  const { toggleModal, hideModal } = ModalContext.useModalContext();

  const toggleClickAndCollectModal = React.useCallback(() => {
    trackModalOpen({ timing: getTimeFromInit() });

    const handleModalCloseTracking = () => {
      hideModal();
      trackModalClose({ timing: getTimeFromInit() });
      onModalClosing();
    };

    toggleModal(
      <ClickAndCollectModal
        selectedVariant={selectedVariant}
        product={product}
      />,
      {
        header: formatMessage(modalMessages.chooseStore),
        center: true,
        withFocusTrap: true,
        onClose: handleModalCloseTracking,
      }
    );
  }, [
    getTimeFromInit,
    toggleModal,
    selectedVariant,
    product,
    formatMessage,
    hideModal,
    onModalClosing,
  ]);

  return (
    <PickUpButtonWrapper>
      <PickUpButton
        data-cypress="click-and-collect"
        newDesign={newDesign}
        fullWidth={true}
        buttonStyle={ButtonModel.Styles.secondary}
        onClick={toggleClickAndCollectModal}
        disabled={disabled}
      >
        <FormattedMessage {...messages.pickupNow} />
      </PickUpButton>
    </PickUpButtonWrapper>
  );
};
